export default __webpack_public_path__ + "static/media/googleMaps.acf64d0c.png";